import { createQueryKeys } from "@lukemorales/query-key-factory";

import { createServiceResponseSchema, privateApi } from "@/api/axios";
import { profileDataModelSchema } from "@/domains/profile/models/schemas";

export const profileQueryOptions = createQueryKeys("profile", {
  current: {
    queryKey: null,
    queryFn: () => {
      return getProfile();
    },
  },
});

export const getProfile = async () => {
  const response = await privateApi.get("/me");

  return createServiceResponseSchema(profileDataModelSchema).parse(response.data).data;
};
